import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { IAlertaBikeStore } from "..";

import { IConsultaBike } from "../../../interface/bike";

export interface IBikeStore {
  resultadoBike: IConsultaBike[] | null;
  mensagemBike?: string;
  consultaBikes(url: string, getChassi: string, e?: FormEvent): Promise<void>;
  limparConsultaBike(): void;
}

export default (set: SetState<IAlertaBikeStore>) =>
  ({
    resultadoBike: null,
    async consultaBikes(url, getChassi, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        if (getChassi === "") {
          toast.error("Preencha o campo!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        } else {
          const response = await axios.get(
            `${url}/alertaBike/listarBike/${getChassi.toUpperCase()}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );

          if (response.status === 200) {
            if (response.data === "NÃO ALERTADO") {
              toast.error(`${response.data}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              });

              return;
            }
            set((state) => ({
              ...state,
              global: {
                ...state.global,
                loading: false,
              },
              bike: {
                ...state.bike,
                resultadoBike: response.data,
              },
            }));
          }
          if (response.status === 400) {
            toast.error(`${response.data}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 401) {
            toast.error(
              "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            // logout()
          }
          if (response.status === 404) {
            set((state) => ({
              bike: {
                ...state.bike,
                resultadoBike: null,
                mensagemBike: response.data,
              },
            }));
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            return;
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            return;
          }
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaBike() {
      set((state) => ({
        ...state,
        bike: {
          ...state.bike,
          resultadoBike: null,
          mensagemBike: undefined,
        },
      }));
    },
  } as IBikeStore);
